import { IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FirstPage, LastPage, KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';

interface TablePaginationActionsProps {
  canPreviousPage: boolean;
  canNextPage: boolean;
  gotoPage: (page: number) => void;
  previousPage: () => void;
  nextPage: () => void;
  pageCount: number;
}

/**
 * Note: First / Last page buttons are rendered but visually hidden via CSS
 * (`.ui-table__page-actions .MuiIconButton-root[aria-label="first page"]`)
 * to match the target design, which only shows prev / next. They remain in
 * the DOM so keyboard users on other surfaces still have the option.
 */
const TablePaginationActions: React.FC<TablePaginationActionsProps> = ({
  canPreviousPage,
  canNextPage,
  gotoPage,
  previousPage,
  nextPage,
  pageCount,
}) => {
  const theme = useTheme();
  const isRtl = theme.direction === 'rtl';

  return (
    <>
      {pageCount > 1 && (
        <IconButton onClick={() => gotoPage(0)} disabled={!canPreviousPage} aria-label='first page' size='small'>
          {isRtl ? <LastPage /> : <FirstPage />}
        </IconButton>
      )}
      <IconButton onClick={previousPage} disabled={!canPreviousPage} aria-label='previous page' size='small'>
        {isRtl ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton onClick={nextPage} disabled={!canNextPage} aria-label='next page' size='small'>
        {isRtl ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      {pageCount > 1 && (
        <IconButton onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage} aria-label='last page' size='small'>
          {isRtl ? <FirstPage /> : <LastPage />}
        </IconButton>
      )}
    </>
  );
};

export default TablePaginationActions;
